<button mat-button [matMenuTriggerFor]="userMenu" data-cy="user-menu" class="h-16 max-h-16 rounded-none leading-normal">
  <div class="flex flex-row justify-center items-center">
    <img
      [src]="user?.avatar || defaultAvatar"
      class="h-8 w-8 rounded-full max-w-none mr-0 md:mr-4"
      alt="Avatar Image"
    />
    <div class="flex flex-col md:max-w-52 lg:max-w-72">
      <div class="username mr-7 hidden md:block md:truncate" *ngIf="user?.name">
        {{ user?.name }}
      </div>

      <div class="text-xs mr-7 hidden md:flex">
        {{ workspaceName }}
      </div>
    </div>
    <mat-icon class="s-4 hidden md:flex" data-test="navbar-button">keyboard_arrow_down </mat-icon>
  </div>
</button>

<mat-menu #userMenu="matMenu" [overlapTrigger]="false">
  <div class="sm:hidden block px-6 sm:px-16">
    <ng-container *ngIf="user?.name">
      <div>
        <span class="text-sm font-semibold">{{ user?.name }}</span
        ><br />
        <span class="text-xs">{{ workspaceName }}</span>
      </div>
    </ng-container>
  </div>

  <button mat-menu-item data-test="user-menu-profile" (click)="profileClick()">
    <mat-icon>account_circle</mat-icon>
    <span>{{ 'UI.USER_MENU.PROFILE' | transloco }}</span>
  </button>

  <button mat-menu-item data-cy="user-menu-settings" [routerLink]="settingsRoute" *ngIf="isAdmin">
    <mat-icon>settings</mat-icon>
    <span>{{ 'UI.USER_MENU.SETTINGS' | transloco }}</span>
  </button>

  <button mat-menu-item data-test="user-menu-changeworkspace" [routerLink]="workspacesRoute">
    <mat-icon>business</mat-icon>
    <span>{{ 'UI.USER_MENU.CHANGE_WORKSPACE' | transloco }}</span>
  </button>

  <button mat-menu-item data-test="user-menu-logout" (click)="logoutClick()">
    <mat-icon>exit_to_app</mat-icon>
    <span>{{ 'UI.USER_MENU.LOGOUT' | transloco }}</span>
  </button>
</mat-menu>
